import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class InscriptionService {
    static async update(id, data) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation INSCRIPTION_UPDATE(
          $id: String!
          $data: InscriptionInput!
        ) {
          inscriptionUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

            variables: {
                id,
                data,
            },
        });

        return response.data.inscriptionUpdate;
    }

    static async changeStatus({ id, status, teams }) {
        const response = await graphqlClient.mutate({
            mutation: gql `
            mutation INSCRIPTION_CHANGE_STATUS ($id:String!, $status:InscriptionStatus!, $teams: [TeamInput] ) {
              inscriptionChangeStatus (id:$id, status:$status, teams:$teams) 
            }
      `,
            variables: {
                id,
                status,
                teams
            },
        });

        return response.data.inscriptionChangeStatus;
    }

    static async destroyAll(ids) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation INSCRIPTION_DESTROY($ids: [String!]!) {
          inscriptionDestroy(ids: $ids)
        }
      `,

            variables: {
                ids,
            },
        });

        return response.data.inscriptionDestroy;
    }

    static async create(data) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation INSCRIPTION_CREATE($data: InscriptionInput!) {
          inscriptionCreate(data: $data) {
            id
          }
        }
      `,

            variables: {
                data,
            },
        });

        return response.data.inscriptionCreate;
    }

    static async import (values, importHash) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation INSCRIPTION_IMPORT(
          $data: InscriptionInput!
          $importHash: String!
        ) {
          inscriptionImport(data: $data, importHash: $importHash)
        }
      `,

          variables: {
              data: values,
              importHash,
          },
        });

        return response.data.inscriptionImport;
    }

    static async find(id) {
        const response = await graphqlClient.query({
            query: gql `
        query INSCRIPTION_FIND($id: String!) {
          inscriptionFind(id: $id) {
            id
            user {
              id
              firstName
              lastName
              fullName
              gender
              phoneNumber {
                prefix
                number
              }
              email
              birthdate {
                day
                month
                year
              }
              identDoc
              address {
                city
                country
                line1
                line2
                postalCode
                state
              }
            }
            status
            firstName
            lastName
            birthdate {
              day
              month
              year
            }
            gender
            isMember
            careerInfo
            identDoc
            identDocFiles {
              id
              name
              type
              sizeInBytes
              publicUrl
              privateUrl
            }
            additionalDocFiles {
              id
              name
              type
              sizeInBytes
              publicUrl
              privateUrl
            }
            program {
              id
              name
              type
            }

            subprogram {
              id
              name
              additionalDoc {
                text
              }
              payment {
                exist
              }
            }
            charges {
              createdAt
              id
              amount
              currency
              applicationFee
              stripeFee
              status
            }
            createdAt
            updatedAt
          }
        }
      `,

            variables: {
                id,
            },
        });

        return response.data.inscriptionFind;
    }

    static async list(filter, orderBy, limit, offset) {
        const response = await graphqlClient.query({
            query: gql `
        query INSCRIPTION_LIST(
          $filter: InscriptionFilterInput
          $orderBy: InscriptionOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          inscriptionList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              user {
                id
                fullName
                email
              }
              status
              firstName
              lastName
              birthdate {
                day
                month
                year
              }
              gender
              isMember
              careerInfo
              identDoc
              identDocFiles {
                id
                name
                sizeInBytes
                publicUrl
                privateUrl
              }
              additionalDocFiles {
                id
                name
                sizeInBytes
                publicUrl
                privateUrl
              }
              program {
                id
                name
                type
              }
              subprogram {
                id
                name
                payment {
                  exist
                }
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

            variables: {
                filter,
                orderBy,
                limit,
                offset,
            },
        });

        return response.data.inscriptionList;
    }

    static async listAutocomplete(query, limit) {
        const response = await graphqlClient.query({
            query: gql `
        query INSCRIPTION_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          inscriptionAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

            variables: {
                query,
                limit,
            },
        });

        return response.data.inscriptionAutocomplete;
    }

    static async balance(subpropertyId) {
      const response = await graphqlClient.query({
        query: gql`
          query BALANCE(
            $subpropertyId: String!
          ) {
            stripeSubpropertyDataFind(
              subpropertyId: $subpropertyId
            ) {
              totalPaid{
                amount
                currency
              }
              balancePending{
                amount
                currency
              }
            }
          }
        `,
  
        variables: {
          subpropertyId
        },
      });
  
      return response.data.stripeSubpropertyDataFind;
    }
}